import React, { useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import BarcodeLabel from "./BarcodeLabel";
import FileSelector from "./FileSelector";

const PrintBarcode = () => {
  const printContainerRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printContainerRef.current,
  });

  const [barcodes, setBarcodes] = useState([]);
  const [showFileSelector, setShowFileSelector] = useState(true);

  const handleFileSelect = (data) => {
    const filteredData = data.barcode.map((item) => ({
      Code: item.Code,
      Quantity: item.Quantity,
      ManufacturingDate: item.ManufacturingDate,
      Batch: item.Batch,
    }));
    setBarcodes(filteredData);
    setShowFileSelector(false);
  };

  const allBarcodeLabels = barcodes.flatMap((barcode, index) =>
    Array.from({ length: Math.ceil(barcode.Quantity / 2) }).map((_, idx) => (
      <div key={`${index}-${idx}`} style={{ pageBreakAfter: "always" }}>
        <BarcodeLabel code={barcode.Code} batch={barcode.Batch} />
        
      </div>
    ))
  );

  return (
    <div>
      <button onClick={handlePrint}>Print Barcode</button>
      <div ref={printContainerRef}>
        {showFileSelector && (
          <div style={{ pageBreakAfter: "always" }}>
            <FileSelector
              onFileSelect={handleFileSelect}
              hideFileInput={false}
            />
          </div>
        )}
        {allBarcodeLabels}
      </div>
    </div>
  );
};

export default PrintBarcode;
